/**
 * @file: SidebarCreditBalanceLabel.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { formatAiCredits } from '@euler/app/components/ai/overlay/functions/formatAiCredits';
import { useAiCreditBalance } from '@euler/app/components/ai/overlay/functions/useAiCreditBalance';
import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';

/** The store's AI credits left, fetched when it mounts. */
export const SidebarCreditBalanceLabel = memo(
  ({ color }: { color: string }) => {
    const { rpx } = useResponsiveContext();
    const credit = useAiCreditBalance();
    if (credit == null) return null;
    return (
      <Typography.Text
        size={rpx(12)}
        color={color}
        numberOfLines={1}
        // Half its row's color: a footnote to 知车AI, not an item.
        style={{ marginTop: rpx(2), opacity: 0.5 }}
      >
        剩余积分：{formatAiCredits(credit.balance)}
      </Typography.Text>
    );
  },
);
